export enum CardType {
    VISA = 'Visa',
    MASTER_CARD = 'MasterCard',
    JCB = 'JCB', // Unverified
    UNION_PAY = 'UnionPay', // Unverified
}
